import React from "react";

const ShowsList = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6 py-6 sm:py-10">
        {/* Card wrapper (same theme vibe) */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
          {/* Header pill (optional accent) */}
          <div
            className="px-4 sm:px-6 py-3 sm:py-4 text-white text-sm sm:text-base font-semibold"
            style={{ backgroundColor: "#671111" }}
          >
            Grand Cinemaz • Book Tickets
          </div>

          {/* Iframe area */}
          <div className="p-3 sm:p-6">
            <div className="rounded-xl overflow-hidden border border-gray-200 shadow-sm">
              <iframe
                title="Grand Cinemaz - BookMyShow"
                src="https://cinemas.bookmyshow.com/iframe?domain=grandcinemaz.com"
                allowTransparency={true}
                scrolling="auto"
                frameBorder="0"
                // Responsive: full width, tall enough to avoid inner scrolling
                style={{
                  width: "100%",
                  height: "70vh",
                  overflow: "auto",
                  background: "#fff",
                  display: "block",
                }}
              />
            </div>

            {/* Fallback link if iframe is blocked */}
         
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowsList;
